import React from 'react'

interface CircleItemBulletPointProps {
  label: string
}

export function CircleItemBulletPoint ({ label }: CircleItemBulletPointProps) {
  return (
    <div className='w-5 h-5 mt-0.5 p-2 flex items-center justify-center rounded-full border border-gray-500 text-500 caption'>
      {label}
    </div>
  )
}
